import { makeContextModule } from '@cian/react-utils';

var _makeContextModule = makeContextModule({
  contextName: 'SliderContext'
}),
    SliderContext = _makeContextModule.Context,
    useSliderContext = _makeContextModule.useContext,
    withSliderContext = _makeContextModule.withContext;

export { SliderContext, useSliderContext, withSliderContext };